import { FC } from 'react';
import styles from '../Slide.module.scss';
import 'react-awesome-slider/dist/styles.css';
import { Link } from 'react-scroll';

const Home: FC = () => {
  return (
    <section id="home">
      <div className={styles.container}>
        <div className={styles['background-shape']} aria-hidden="true"></div>

        <div className={styles['inner-container']}>
          <p className={styles.pretitle}>Senior Frontend Engineer</p>

          <h1 className={styles.title}>Building products from idea to production.</h1>

          <p className={styles.subtitle}>
            I specialize in React and TypeScript, building fast, maintainable frontend products — with the range to take
            a product from idea to production, including backend, AI integrations, and deployment when needed.
          </p>

          <div className={styles.tags}>
            <span>React</span>
            <span>TypeScript</span>
            <span>Frontend Architecture</span>
            <span>Node.js</span>
            <span>AI</span>
            <span>Cloud</span>
          </div>

          <div className={styles.actions}>
            <Link className={styles['primary-action']} to="projects" smooth={true} duration={500} offset={-60}>
              Explore Projects
            </Link>

            <a className={styles['secondary-action']} href="/files/CV_JoseCerejo.pdf" download>
              Download CV
            </a>
          </div>
        </div>

        <picture>
          <img className={styles.image} src="/images/me.webp" alt="Jose Cerejo profile" />
        </picture>
      </div>
    </section>
  );
};

export default Home;
